import React from 'react';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import classes from './LoadingSpinner.module.css';

export const LoadingSpinner = ({ ...rest }) => {
  return (
    <AiOutlineLoading3Quarters className={classes.loadingSpinner} {...rest} />
  );
};

export const PageLoadingSpinner = () => {
  return (
    <div className={classes.loadingContainer}>
      <LoadingSpinner />
    </div>
  );
};
